import { useMemo } from "react";

export type ReportItem = Record<string, any>;

export const useReportByType = <T extends string>(
  reportData?: ReportItem[]
): Partial<Record<T, ReportItem>> => {

  return useMemo(() => {
    if (!reportData) return {};

    return reportData.reduce<Partial<Record<T, ReportItem>>>((acc, item) => {
      acc[item.report_type as T] = item;

      return acc;
    }, {});
  }, [reportData]);
};
